export default __webpack_public_path__ + "static/media/profileImg11.a8b33b32.png";